import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "dropdownContent",
  class: "flex items-center justify-center p-0.5 rounded-[4px] border border-solid border-important-border shadow-md bg-important-bg"
}

import { Editor } from '@tiptap/core';
import { ref, getCurrentInstance, computed } from 'vue';
import type { MenuItemFn } from '@/components/editor/toolbar/menu-item';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import MenuSection from '@/components/editor/toolbar/MenuSection.vue';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownMenuSection',
  props: {
    command: { type: Function },
    dropdownCommands: { type: Function },
    editor: {}
  },
  setup(__props: any) {

const props = __props;

const { iconPath, getCustomIconStyle } = useCustomIcon();
const { translate } = useTranslate();
const _this = getCurrentInstance();

const dropdownParent = ref();
const dropdownButton = ref();

const handleKeyDown = (event: KeyboardEvent) => {
  isTextAlignShortcut(event);
};

const preventAndStop = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
};

const isTextAlignShortcut = (event: KeyboardEvent) => {
  const key = event.key;
  const textAlignMap: { [key: string]: string } = {
    r: 'right',
    l: 'left',
    c: 'center',
  };

  // Check if Ctrl or Command and Shift keys are pressed
  if (!(event.ctrlKey || event.metaKey) || !event.shiftKey || !textAlignMap[key]) {
    return;
  }

  preventAndStop(event);
  props.editor.chain().focus().setTextAlign(textAlignMap[key]).run();
};

const command = computed(() =>
  props.command({
    editor: props.editor,
    translate,
    store: (_this?.proxy as any).$store!,
  })
);

const icon = computed(() => iconPath(command.value.icon()));

return (_ctx: any,_cache: any) => {
  const _component_v_popover = _resolveComponent("v-popover")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownParent",
    ref: dropdownParent,
    class: "flex tb-button-group !border-l-0 dropdown-menu-section"
  }, [
    _createVNode(_component_v_popover, {
      interactive: "",
      tag: "div",
      "content-tag": "div",
      placement: "bottom-start",
      class: "p-0",
      trigger: 'click',
      role: 'poper'
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          ref_key: "dropdownButton",
          ref: dropdownButton,
          class: _normalizeClass({ 'disabled-toolbar-option': command.value?.disabled() }),
          onKeydown: _withModifiers(handleKeyDown, ["stop","prevent"])
        }, [
          _createElementVNode("em", {
            class: "custom-icons",
            style: _normalizeStyle(_unref(getCustomIconStyle)(icon.value))
          }, null, 4)
        ], 34)
      ]),
      content: _withCtx(({ state }) => [
        (state.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(MenuSection, {
                editor: props.editor,
                commands: props.dropdownCommands
              }, null, 8, ["editor", "commands"])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})